import { ValidationMessages } from 'context/validation';

export type CrmPostResult = {
  success: boolean;
  errors?: ValidationMessages;
};

function ensureObject(cand: unknown): Record<string, unknown> {
  if (cand && typeof cand === 'object' && !Array.isArray(cand)) {
    return cand as Record<string, unknown>;
  }
  return {};
}

export function mapValueToCrmPostResult(value: unknown): CrmPostResult | null {
  const obj = ensureObject(value);

  if (typeof obj.success === 'boolean') {
    return {
      success: obj.success,
      errors: (obj.errors ?? null) as ValidationMessages,
    };
  }

  return null;
}
